<template>
  <div>
    <Header />
    <div class="contact-header">
      <h1>PROJELER</h1>
    </div>
    <div class="gallery">
      <div
        v-for="(image, index) in paginatedImages"
        :key="index"
        class="gallery-item"
        @click="showLightbox(index)"
      >
        <img
          :src="image.thumb"
          :alt="'Image ' + (currentPage - 1) * itemsPerPage + index + 1"
        />
        <div class="overlay">
          <i class="fa fa-plus plus" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <!-- Sayfalama -->
    <div class="pagination">
      <button
        v-if="currentPage > 1"
        @click="changePage(currentPage - 1)"
        aria-label="Önceki Sayfa"
      >
        &laquo; Önceki
      </button>
      <button
        v-for="page in visiblePages"
        :key="page"
        :class="{ active: currentPage === page }"
        @click="changePage(page)"
        :aria-label="'Sayfa ' + page"
      >
        {{ page }}
      </button>
      <button
        v-if="currentPage < totalPages"
        @click="changePage(currentPage + 1)"
        aria-label="Sonraki Sayfa"
      >
        Sonraki &raquo;
      </button>
    </div>

    <!-- Lightbox Bileşeni -->
    <vue-easy-lightbox
      v-if="isLightboxVisible"
      :visible="isLightboxVisible"
      :imgs="imageSources"
      :index="currentImageIndex"
      @hide="hideLightbox"
    />

    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  name: "ProjectsViews",
  components: {
    Header,
    Footer,
    VueEasyLightbox,
  },
  data() {
    return {
      images: [
        {
          id: 29,
          title: "",
          alt: "established",
          filter: "fashion",
          thumb: require("@/assets/projects/col3.jpg"),
          src: require("@/assets/projects/col3.jpg"),
        },
        {
          id: 1,
          title: "",
          alt: "established",
          filter: "fashion",
          thumb: require("@/assets/projects/col1.jpg"),
          src: require("@/assets/projects/col1.jpg"),
        },
        {
          id: 2,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img1.jpg"),
          src: require("@/assets/projects/img1.jpg"),
        },
        {
          id: 3,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img2.jpg"),
          src: require("@/assets/projects/img2.jpg"),
        },
        {
          id: 4,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img3.jpg"),
          src: require("@/assets/projects/img3.jpg"),
        },
        {
          id: 5,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img4.jpg"),
          src: require("@/assets/projects/img4.jpg"),
        },
        {
          id: 6,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img5.jpg"),
          src: require("@/assets/projects/img5.jpg"),
        },
        {
          id: 7,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img6.jpg"),
          src: require("@/assets/projects/img6.jpg"),
        },
        {
          id: 8,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img7.jpg"),
          src: require("@/assets/projects/img7.jpg"),
        },
        {
          id: 9,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img8.jpg"),
          src: require("@/assets/projects/img8.jpg"),
        },
        {
          id: 10,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img9.jpg"),
          src: require("@/assets/projects/img9.jpg"),
        },
        {
          id: 11,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img10.jpg"),
          src: require("@/assets/projects/img10.jpg"),
        },
        {
          id: 12,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img11.jpg"),
          src: require("@/assets/projects/img11.jpg"),
        },
        {
          id: 13,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img12.jpg"),
          src: require("@/assets/projects/img12.jpg"),
        },
        {
          id: 14,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img13.jpg"),
          src: require("@/assets/projects/img13.jpg"),
        },
        {
          id: 15,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img14.jpg"),
          src: require("@/assets/projects/img14.jpg"),
        },
        {
          id: 16,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img15.jpg"),
          src: require("@/assets/projects/img15.jpg"),
        },
        {
          id: 17,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img16.jpg"),
          src: require("@/assets/projects/img16.jpg"),
        },
        {
          id: 18,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img17.jpg"),
          src: require("@/assets/projects/img17.jpg"),
        },
        {
          id: 19,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img18.jpg"),
          src: require("@/assets/projects/img18.jpg"),
        },
        {
          id: 20,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img19.jpg"),
          src: require("@/assets/projects/img19.jpg"),
        },
        {
          id: 21,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img20.jpg"),
          src: require("@/assets/projects/img20.jpg"),
        },
        {
          id: 22,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img21.jpg"),
          src: require("@/assets/projects/img21.jpg"),
        },
        {
          id: 23,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img22.jpg"),
          src: require("@/assets/projects/img22.jpg"),
        },
        {
          id: 24,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img23.jpg"),
          src: require("@/assets/projects/img23.jpg"),
        },
        {
          id: 25,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img24.jpg"),
          src: require("@/assets/projects/img24.jpg"),
        },
        {
          id: 26,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img25.jpg"),
          src: require("@/assets/projects/img25.jpg"),
        },
        {
          id: 27,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img26.jpg"),
          src: require("@/assets/projects/img26.jpg"),
        },
        {
          id: 28,
          title: "",
          alt: "readable",
          filter: "shoes",
          thumb: require("@/assets/projects/img27.jpg"),
          src: require("@/assets/projects/img27.jpg"),
        },
        {
          id: 30,
          title: "",
          alt: "established",
          filter: "fashion",
          thumb: require("@/assets/projects/img28.jpg"),
          src: require("@/assets/projects/img28.jpg"),
        },
        {
          id: 31,
          title: "",
          alt: "established",
          filter: "fashion",
          thumb: require("@/assets/projects/img29.jpg"),
          src: require("@/assets/projects/img29.jpg"),
        },
      ],
      itemsPerPage: 12,
      currentPage: 1,
      isLightboxVisible: false,
      currentImageIndex: 0,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.images.length / this.itemsPerPage);
    },
    paginatedImages() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.images.slice(start, start + this.itemsPerPage);
    },
    imageSources() {
      return this.images.map((image) => image.src);
    },
    visiblePages() {
      const range = [];
      const delta = 2;
      const left = Math.max(1, this.currentPage - delta);
      const right = Math.min(this.totalPages, this.currentPage + delta);

      for (let i = left; i <= right; i++) {
        range.push(i);
      }

      if (left > 1) range.unshift("...");
      if (right < this.totalPages) range.push("...");
      if (!range.includes(1)) range.unshift(1);
      if (!range.includes(this.totalPages)) range.push(this.totalPages);

      return range;
    },
  },
  methods: {
    changePage(page) {
      if (page === "...") return;
      this.currentPage = page;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    showLightbox(index) {
      this.currentImageIndex =
        (this.currentPage - 1) * this.itemsPerPage + index;
      this.isLightboxVisible = true;
      document.body.style.overflow = "hidden";
    },
    hideLightbox() {
      this.isLightboxVisible = false;
      document.body.style.overflow = "";
    },
  },
  mounted() {
    document.title = "Ayyıldız Mobilya - Projeler";
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
};
</script>

<style>
/* Galeri Stilleri */
.gallery {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin: 50px auto;
  max-width: 1360px;
}

@media (max-width: 768px) {
  .gallery {
    grid-template-columns: repeat(1, 1fr);
  }
}

.gallery-item {
  position: relative;
  overflow: hidden;
  height: auto; /* Sabit yükseklik (isteğe göre değiştirilebilir) */
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Resmi çerçeveye sığdırır, taşan kısmı kırpar */
  /* border-radius: 10px; */
  transition: 0.3s ease-in-out;
}

.gallery-item:hover img {
  transform: scale(1.1); /* Hover sırasında büyütme */
}

.gallery-item .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.4s ease-in-out;
  border-radius: 10px;
}

.gallery-item:hover .overlay {
  opacity: 1;
}

.gallery-item .overlay i {
  font-size: 2rem;
  color: white;
  transform: scale(1);
  transition: 0.4s ease-in-out;
  opacity: 0;
}

.gallery-item:hover .overlay i {
  transform: scale(1);
  opacity: 1;
}

/* Lightbox Paket Stili */
.lightbox {
  z-index: 2000;
}

/* Sayfalama Stilleri */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  flex-wrap: nowrap; /* Satırda tut */
  overflow-x: auto; /* Yatay kaydırma */
  -webkit-overflow-scrolling: touch; /* Mobilde daha akıcı kaydırma */
  padding: 10px;
}

.pagination::-webkit-scrollbar {
  display: none; /* Tarayıcı kaydırma çubuğunu gizle */
}

.pagination button {
  margin: 0 5px;
  padding: 10px 15px;
  font-size: 16px;
  color: #333;
  background-color: #f0f0f0;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  flex-shrink: 0; /* Butonlar sıkışmasın */
}

.pagination button.active {
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.pagination button:hover:not(.active) {
  background-color: #ddd;
}

.pagination button:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

.pagination button[aria-label="Önceki Sayfa"],
.pagination button[aria-label="Sonraki Sayfa"] {
  font-weight: bold;
}

@media (max-width: 768px) {
  .pagination {
    padding: 0 15px;
  }

  .pagination button {
    font-size: 15px; /* Daha küçük yazı */
    padding: 8px 12px;
    margin: 0 3px;
  }
}

.contact-header {
  text-align: center;
  margin-bottom: 40px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.contact-header h1 {
  font-size: 2.5rem;
  color: #333;
}
</style>
